import React from 'react'
export const HomeHeroBlockSettings = (settingsProps) => {
  return (
    <>
      <div className="empty-message">
        <p>No options available</p>
      </div>
    </>
  )
}
